import BlockView from 'views/block/base-block-view';
import ContentService from 'services/content-service';

export default class ComponentView extends BlockView {
  constructor(options) {
    super(options);
    this.model.set('cid', this.model.cid);
    let path = this.model.get('path');
    let location = this.model.get('location') || 'components';
    let template = path ? require(`${location}/${path}`) : null;
    let parameters = this.model.get('parameters');
    if(template) {
      let deserialized = {};
      try {
        deserialized = JSON.parse(template(parameters));
      } catch(e) {
        deserialized = YAML.parse(template(parameters));
      }
      this.model.set('blocks', deserialized.blocks);
    }
  }

  load() {
    const config = () => {
      let configs = {
        path: this.model.get('path'),
        data: this.model.get('configs'),
        parameters: this.model.get('parameters'),
        cid: this.model.get('cid')
      };
      Chaplin.mediator.publish('page:custom:partial', configs);
    };
    if(this.model.get('blocks')) {
      this.renderNestedBlocks(`${this.model.get('cid')}-blocks`, this.model.get('blocks')).then(config);
    } else if(this.model.get('configs')) {
      config();
    }
  }

  play() {
    this.readyToGo();
  }
}
